import * as apiGetFilesInScope from "@/api/vp/venueDrive/getFilesInScope";
import * as apiSetDomainPermission from "@/api/vp/venueDrive/setDomainPermission";

export default {
    namespaced: true,
    state: {
        loading: false,
        currentScopeFiles: [],
    },
    mutations: {
        gotFilesInScope(state, result) {
            console.log("SCOPE FILES", result);
            state.currentScopeFiles = result;
        },
        changeLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        async listDirectory({ commit }, { folderId, venueId }) {
            commit("changeLoading", true);

            const result = await apiGetFilesInScope.get(folderId, venueId);
            if (result) {
                commit("gotFilesInScope", result);
            }

            commit("changeLoading", false);
        },
        async setDomainPermission({ commit }, fileId) {
            await apiSetDomainPermission.post(fileId);
        },
    },
    getters: {
        currentScopeFiles: state => state.currentScopeFiles,
        loading: state => state.loading,
    }
};